import React from "react";
import authLogoLight from "@/assets/auth-logo-light.png";
import authLogoDark from "@/assets/auth-logo-dark.png";
import { Link } from "react-router-dom";
import { useTheme } from "@/components/ThemeProvider";

export const AuthLogo: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Link to="/">
      <img
        src={isDark ? authLogoDark : authLogoLight}
        className="cursor-pointer w-16 h-16 object-contain"
        alt="Shattara AI Logo"
      />
    </Link>
  );
};
